const TIER_DOT: Record<string, string> = {
  dream: "bg-amber",
  realistic: "bg-primary",
  safety: "bg-safety",
};

/** Small dot in the tier color, so Dream / Realistic / Safety read the same on every surface. */
export function TierDot({ tier, className = "" }: { tier?: string | null; className?: string }) {
  const color = tier ? TIER_DOT[tier] : undefined;
  if (!color) return null;
  return (
    <span
      aria-hidden="true"
      className={`inline-block h-2 w-2 shrink-0 rounded-full ring-1 ring-black/10 ${color} ${className}`}
    />
  );
}
